export default "__VITE_ASSET__CyVdx0gN__"